import { memo, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import { SearchStatus } from '../../../../constants';
import OverviewDetails from './OverviewDetails';
import GoodToKnowDetails from './GoodToKnowDetails';
import MeetingLocationDetails, { hasMeetingLocation } from './MeetingLocationDetails';
import OperatorDetails, { hasOperatorDetails } from './OperatorDetails';
import ReviewsDetails from './ReviewsDetails';
import TourPhotos from './TourPhotos';
import TabPanel from '../../../TabPanel';

const TourDetails = ({ itinerary, details }) => {
  const selectedTabClasses = 'text-theme border-b-2 border-theme';
  const photos = details?.product?.images || itinerary.tour?.images || [];
  const tabs = [
    {
      title: 'Overview',
      content: <OverviewDetails itinerary={itinerary} product={details && details.product} />,
    },
    {
      title: 'Good to know',
      content: <GoodToKnowDetails itinerary={itinerary} product={details && details.product} />,
    },
    ...(hasMeetingLocation(itinerary, details && details.product)
      ? [
          {
            title: 'Meeting location',
            content: (
              <MeetingLocationDetails itinerary={itinerary} product={details && details.product} />
            ),
          },
        ]
      : []),
    ...(photos.length ? [{ title: 'Photos', content: <TourPhotos images={photos} /> }] : []),
    ...(details && details.product && (details.product.reviews || []).length
      ? [
          {
            title: `Reviews (${details.product.reviewCount || details.product.reviews.length})`,
            content: <ReviewsDetails product={details.product} />,
          },
        ]
      : []),
    ...(hasOperatorDetails(itinerary)
      ? [{ title: 'From the operator', content: <OperatorDetails itinerary={itinerary} /> }]
      : []),
  ];
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (index) => {
    setSelectedTab(index);
  };

  if (!details?.product && details?.status === SearchStatus.SEARCHING) {
    return (
      <div className="py-8 text-center">
        <CircularProgress color="secondary" size={28} />
      </div>
    );
  }

  return (
    <div>
      <div className="grid grid-flow-col auto-cols-max gap-5 md:gap-1 border-b-2 mb-5 overflow-x-auto">
        {tabs.map((tab, index) => (
          <a
            key={tab.title}
            onClick={() => {
              handleTabChange(index);
            }}
            onKeyDown={() => {
              handleTabChange(index);
            }}
            role="button"
            tabIndex={tabs.length - index}
            className={clsx(
              selectedTab === index && selectedTabClasses,
              'py-4 px-3 text-sm mt-auto md:text-base lg:min-w-24 text-center focus:outline-none block w-full whitespace-no-wrap',
            )}
          >
            {tab.title}
          </a>
        ))}
      </div>
      {tabs.map((tab, index) => (
        <TabPanel value={selectedTab} index={index} key={tab.title}>
          {tab.content}
        </TabPanel>
      ))}
    </div>
  );
};
TourDetails.propTypes = {
  itinerary: PropTypes.shape().isRequired,
  details: PropTypes.shape(),
};
TourDetails.defaultProps = {
  details: undefined,
};

export default memo(TourDetails);
